var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.localClassBtn,attrs:{"rounded":"","large":_vm.large},on:{"click":_vm.navigateToStore}},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t("$vuetify.downloadAppLabel"))+" "),_c('v-icon',{attrs:{"right":"","size":_vm.sizeIcon}},[_vm._v(" mdi-chevron-right")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }